import React, {useEffect, useState} from "react";
import {UserApiCalls} from "../../apis/UserApiCalls";
import {useSession} from "../../hooks/useSession";
import {usePPTWebView} from "../../hooks/usePPTWebView";
import {PublicApiCall} from "../../apis/PublicApiCall";
import {useLocalStorageNew} from "../../hooks/useLocalStorageNew";
import {ROLES} from "../../utils/constants";
import {useConfig} from "../../hooks/useConfig";
import {AuthenticationApiCalls} from "../../apis/AuthenticationApiCalls";
import {getShortName} from "../../utils/helpers";

export default function NPSSurveyModal({}) {
    const {loadUser, updateNPSSurvey} = UserApiCalls();
    const {resolveShortName} = PublicApiCall();
    const {getAuthCount} = AuthenticationApiCalls();
    const {parseSessionToken} = useSession();
    const {isPPTPage, parseToken} = usePPTWebView();
    const config = useConfig();
    const {institutionId, userId, role} = isPPTPage() ? parseToken() : parseSessionToken();
    const [, getInstitution] = useLocalStorageNew(window.location.hostname, {});


    let shortName = getShortName();


    const [isOpen, setIsOpen] = useState(false);
    const [instName, setInstName] = useState("");
    const [userName, setUserName] = useState("");
    const [email, setEmail] = useState("");
    const [yujaAccountId, setYujaAccountId] = useState("");



    useEffect(() => {
        let promise1 = loadUser(institutionId, userId).catch((e) => {
            console.log(e);
            return {};
        });
        let promise2 = isPPTPage() ? resolveShortName(shortName).catch((e) => {
            console.log(e);
            return {};
        }) : new Promise(resolve => {
            let institution = getInstitution();
            resolve(institution);
        });

        let promise3 = getAuthCount();

        Promise.all([promise1, promise2, promise3]).then(([res, resource, count]) => {
            if (!Object.keys(res).length || !Object.keys(resource).length) {
                setIsOpen(false);
                return;
            }

            // setInstName(resource.fullName);
            setInstName(encodeURIComponent(resource.fullName));


            const { NPSSurveyDate = "", userName="", email="unknown", createdDate="" } = res;
            setUserName(encodeURIComponent(userName));
            setEmail(encodeURIComponent(email));
            setYujaAccountId(encodeURIComponent(resource.yujaAccountId || ""));
            // setFullName(encodeURIComponent(resource.fullName));


            let now = new Date();
            const oneQuarterAgo = new Date();
            oneQuarterAgo.setMonth(now.getMonth() - 3);

            const parts = createdDate.split('-');
            let isAccountOld = true;
            if (!!parts[0] && !!parts[1] && !!parts[2]) {
                const day = parseInt(parts[0]);
                const month = parseInt(parts[1]);
                const year = parseInt(parts[2]);
                const oneMonthLaterCreation = new Date(Date.UTC(year, month - 1, day))
                oneMonthLaterCreation.setMonth(oneMonthLaterCreation.getMonth() + 1);

                if (now < oneMonthLaterCreation) {
                    isAccountOld = false;
                }

            }

            if (count >= 4 && isAccountOld && (!NPSSurveyDate || new Date(NPSSurveyDate) < oneQuarterAgo)) {
                setIsOpen(true);
            } else {
                setIsOpen(false);
            }
        });
    }, []);



    useEffect(() => {
        const handleNPSSurveySubmitMessage = (event) => {
            const {data} = event;
            if (!data || typeof data !== 'object') return;
            if (data.message === 'submit-panorama-survey-score') {
                const now = new Date().toISOString();
                updateNPSSurvey(institutionId, userId, now);
                // setIsOpen(false);
            } else if (data.message === 'close-panorama-survey-modal') {
                const now = new Date().toISOString();
                updateNPSSurvey(institutionId, userId, now);
                setIsOpen(false);
            }
        }

        if (isOpen) {
            window.addEventListener('message', handleNPSSurveySubmitMessage);
        }

        return () => {
            window.removeEventListener('message', handleNPSSurveySubmitMessage);
        }
    }, [isOpen]);

    return (ROLES.IT_MANAGER.value === role && isOpen && !!instName && !!email && !!userName &&
        <div
            style={{
                position: "fixed",
                bottom: 0,
                right: 0,
                width: "min(680px, 100%)",
                height: 320,
                zIndex: 10,
            }}
        >
            <iframe
                style={{width: "100%", height: "100%"}}
                src={`${config.panorama_nps_survey_host}&institutionName=${instName}&userFullName=${userName}&userEmail=${email}&yujaAccountId=${yujaAccountId}`}
            />
        </div>
    );
}